import React from "react";
export const HomeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.25034 7.75L10.0003 2.5L16.7503 7.75V16C16.7503 16.3978 16.5923 16.7794 16.311 17.0607C16.0297 17.342 15.6482 17.5 15.2503 17.5H4.75034C4.35251 17.5 3.97098 17.342 3.68968 17.0607C3.40837 16.7794 3.25034 16.3978 3.25034 16V7.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
